<template>
    <div>
        <a
            v-if="isHighlighted"
            :href="options.Url"
            :class="options.CssClass"
            v-html="options.Text"
        />
        <div
            v-else
        >
            <div class="small-12 medium-3 large-3">
                <a
                    :href="options.Url"
                    :class="options.CssClass"
                    v-html="options.Text"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GenericContentButton',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        isHighlighted: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
};
</script>
